import {Range} from "react-range";
import React, {useEffect, useState} from "react";

const CustomRange = (props) => {
    const [currentRange, setCurrentRange] = useState([props.min, props.max])

    const onChange = ([newMin, newMax]) => {
        setCurrentRange([newMin, newMax]);
        props.onChange([newMin, newMax])
    }

    return (
        <div className="text-center">
            <strong>{props.title}</strong>
            <div className="font-small">
                {currentRange[0]} to {currentRange[1]}
            </div>
            <Range
                step={props.step}
                min={props.min}
                max={props.max}
                values={currentRange}
                onChange={onChange}
                renderTrack={({props, children}) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            position: "relative",
                            height: "0.375rem",
                            background: "#ccc",
                            borderRadius: "0.1875rem",
                            width: "100%",
                            margin: "0.625rem 0",
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({props}) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            position: "absolute",
                            height: "1rem",
                            width: "1rem",
                            borderRadius: "50%",
                            backgroundColor: "#777",
                            top: "50%",
                            marginTop: "-0.2rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    />
                )}
            />
        </div>
    )
}

export default CustomRange;